"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareImageForUpload = prepareImageForUpload;
function decodeImage(file) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, objectUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(typeof createImageBitmap === "function")) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createImageBitmap(file, { imageOrientation: "from-image" })];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    objectUrl = URL.createObjectURL(file);
                    _b.label = 5;
                case 5:
                    _b.trys.push([5, , 7, 8]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var image = new Image();
                            image.onload = function () { return resolve(image); };
                            image.onerror = function () { return reject(new Error("This image could not be read.")); };
                            image.src = objectUrl;
                        })];
                case 6: return [2 /*return*/, _b.sent()];
                case 7:
                    URL.revokeObjectURL(objectUrl);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    });
}
/** Centre-crops to a square and scales to the rule's size, so avatars are small, square and sharp at any display size. */
function prepareImageForUpload(file, rule) {
    return __awaiter(this, void 0, void 0, function () {
        var source, sourceWidth, sourceHeight, cropSize, cropX, cropY, outputSize, canvas, context, blob, baseName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, decodeImage(file)];
                case 1:
                    source = _a.sent();
                    sourceWidth = source.width;
                    sourceHeight = source.height;
                    cropSize = Math.min(sourceWidth, sourceHeight);
                    cropX = (sourceWidth - cropSize) / 2;
                    cropY = (sourceHeight - cropSize) / 2;
                    outputSize = Math.min(rule.size, cropSize);
                    canvas = document.createElement("canvas");
                    canvas.width = outputSize;
                    canvas.height = outputSize;
                    context = canvas.getContext("2d");
                    if (!context) {
                        throw new Error("This browser cannot process images.");
                    }
                    context.imageSmoothingEnabled = true;
                    context.imageSmoothingQuality = "high";
                    context.drawImage(source, cropX, cropY, cropSize, cropSize, 0, 0, outputSize, outputSize);
                    if ("close" in source) {
                        source.close();
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return canvas.toBlob(resolve, rule.contentType, rule.quality); })];
                case 2:
                    blob = _a.sent();
                    if (!blob) {
                        throw new Error("This image could not be processed.");
                    }
                    baseName = file.name.replace(/\.[^.]+$/, "") || "image";
                    return [2 /*return*/, new File([blob], "".concat(baseName, ".").concat(rule.extension), { type: rule.contentType })];
            }
        });
    });
}
